import React from 'react';
import useVideoStyles from './styles';
import VideoPlayer from '../../components/videoPlayer';

const SingleSlide = (props) => {
  const { data } = props;
  const classes = useVideoStyles();

  return (
    <div className={classes.singleSlideContainer}>
      <div
        ref={data?.videoFrame?.refSetter}
        className={classes.iframeContainer}
        style={{
          background: 'linear-gradient(#333333,rgb(0 0 0))'
        }}
      >
        <VideoPlayer
          imageUrl={data.videoFrame.metadata?.thumbnail}
          videoUrl={data.videoFrame.metadata?.value}
        />
      </div>

      <div className={classes.videoDetailsContainer}>
        <h3
          ref={data?.videoTitle?.refSetter}
          className={classes.videoDetailsHeading}
          dangerouslySetInnerHTML={{
            __html: data.videoTitle.metadata.value
          }}
        />
        <div
          ref={data?.videoSubTitle?.refSetter}
          className={classes.videoDetailsSubHeading}
          dangerouslySetInnerHTML={{
            __html: data.videoSubTitle.metadata.value
          }}
        />
      </div>
    </div>
  );
};

export default SingleSlide;
